/* AAVO Scroll Reveal
   Lightweight intersection-based section reveals.
   Gracefully degrades: no JS = no hidden sections. */

(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('aavo-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  var sections = document.querySelectorAll('main > *');
  sections.forEach(function(section, i) {
    if (i === 0) return;
    section.classList.add('aavo-reveal');
    observer.observe(section);
  });
})();
